"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomParagraphs = void 0;
const react_1 = __importDefault(require("react"));
const lorem_ipsum_1 = require("lorem-ipsum");
const Typography_1 = require("../material-ui/Typography");
const lorem = new lorem_ipsum_1.LoremIpsum();
function randomParagraphs(count) {
    const ps = [];
    for (let i = 0; i < count; i++) {
        ps.push(react_1.default.createElement(Typography_1.P, { key: i }, lorem.generateParagraphs(1)));
    }
    return ps;
}
exports.randomParagraphs = randomParagraphs;
//# sourceMappingURL=randomParagraphs.js.map